import type { Signal } from '@angular/core';
import { Service } from '@angular/core';

@Service()
export abstract class OnyxPreferencesService {
  public abstract defaultAreaCode: Signal<string>;
  public abstract defaultCurrency: Signal<string>;
  public abstract defaultCountry: Signal<string>;
}
